export default {
  title: 'Jadwal Pengiriman',
  customerName: 'Nama Customer',
  transporterName: 'Nama Rekanan 3PL',
  transporterFilterLabel: 'Rekanan 3PL:',
  transporterFilterPlaceholderLabel: 'Semua rekanan 3PL',
  customerFilterLabel: 'Customer:',
  customerFilterPlaceholderLabel: 'Semua customer',
  orderCompleted: 'Pesanan Selesai',
  orderInProcess: 'Dalam Proses',
  scheduled: 'Terjadwal',
  canceled: 'Batal',
  today: 'Hari Ini',
}
